import ja                            from "date-fns/locale/ja";
import * as React                    from "react";
import { FC }                        from "react";
import ReactDatePicker               from "react-datepicker";
import "react-datepicker/dist/react-datepicker.min.css";
import { Button, Form, Icon, Popup } from "semantic-ui-react";
import Time                          from "../../../domain/fundamentals/date/Time";

interface Props {
  label: string;
  from: Time;
  to: Time
  onChangeFrom: (value: Time) => void;
  onChangeTo: (value: Time) => void;
  excludeTimes?: Date[];
  helpText?: string;
}

const TimeRangeSelector: FC<Props> = (props: Props) => {
  const {from, to} = props;
  return (
    <>
      <Form.Field>
        <label>
          { props.label }
          {
            props.helpText ?
              <Popup
                trigger={ <Icon name="help circle" style={ {marginLeft: "0.5rem"} }/> }
                size="mini"
              >
                { props.helpText }
              </Popup>
              :
              null
          }
        </label>
        <ReactDatePicker
          onChange={ (date) => props.onChangeFrom(date ? Time.of(date) : from) }
          locale={ ja }
          showTimeSelect={ true }
          showTimeSelectOnly={ true }
          timeCaption="開始"
          dateFormat="hh:mm"
          timeIntervals={ 15 }
          excludeTimes={ props.excludeTimes }
          customInput={
            <Button>
              { from.asAText() }
            </Button>
          }
        />
        <span style={ {margin: "0 0.5rem 0"} }>-</span>
        <ReactDatePicker
          onChange={ (date) => props.onChangeTo(date ? Time.of(date) : to) }
          locale={ ja }
          showTimeSelect={ true }
          showTimeSelectOnly={ true }
          timeCaption="終了"
          dateFormat="hh:mm"
          timeIntervals={ 15 }
          excludeTimes={ props.excludeTimes }
          customInput={
            <Button>
              { to.asAText() }
            </Button>
          }
        />
      </Form.Field>
    </>
  );
};

export default TimeRangeSelector;
